import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from '@app/core/global.module';
import { TableHeaderModule } from '@app/modules/table/children/table-header/modules/table-header.module';
import { TableAutoHeightDirective } from '@app/modules/table/directives/table-auto-height.directive';
import { TableFilterPortalDirective } from '@app/modules/table/directives/table-filter-portal.directive';
import { ButtonModule } from '@components/button/modules/button.module';
import { AppDialogModule } from '@components/dialog/modules/app-dialog.module';
import { InputSearchModule } from '@components/input-search/input-search.module';
import { PanelToolsModule } from '@components/panel-tools/panel-tools.module';
import { SKELETON_LOADER_TOKEN } from '@constants/diConstant';
import { SKELETON_LOADER_CONFIG } from '@constants/mainConstants';
import { RestrictInputDirective } from '@directives/restrict-input/restrict.input.directive';
import { FuiTooltipDirective } from '@fui/fui-components';
import { PaletteLegendComponent } from '@modules/palettes/children/palette-legend/palette-legend.component';
import { EscapeHtmlPipe } from '@pipes/escape-html/escape-html.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HighlightModule } from '../../../shared/directives/highlight/highlight.module';
import { SkeletonDirectiveModule } from '../../../shared/directives/skeleton/skeleton-directive.module';
import { DynamicFieldsModule } from '../dynamic-fields/dynamic-fields.module';
import { FormFilterModule } from '../form-filter/form-filter.module';
import { TableCellsModule } from './children/table-cells/table-cells.module';
import { FilterDialogsComponent } from './dialogs/filter-dialogs/filter-dialogs.component';
import { SettingsTableNameDialogComponent } from './dialogs/settings-table-name/settings.table.name.dialog.component';
import { SettingsTableDialogComponent } from './dialogs/settings-table/settings.table.dialog.component';
import { TableLayerDialogModule } from './dialogs/table-layer-dialog/table-layer-dialog.module';
import { ResizeColumnDirective } from './directives/resize-column.directive';
import { CustomPaginationComponent } from './pagination/custom.pagination.component';
import { CustomSortModule } from './sort/custom.sort.module';
import { TableSkeletonComponent } from './table-skeleton/table-skeleton.component';
import { TableComponent } from './table.component';

@NgModule({
    providers: [{ provide: SKELETON_LOADER_TOKEN, useValue: SKELETON_LOADER_CONFIG }],
    declarations: [
        TableComponent,
        SettingsTableDialogComponent,
        SettingsTableNameDialogComponent,
        FilterDialogsComponent,
        ResizeColumnDirective,
        TableSkeletonComponent,
        CustomPaginationComponent,
        TableAutoHeightDirective,
        TableFilterPortalDirective,
    ],
    imports: [
        CommonModule,
        GlobalModule,
        FormFilterModule,
        DynamicFieldsModule,
        TableLayerDialogModule,
        NgxSkeletonLoaderModule,
        CustomSortModule,
        SkeletonDirectiveModule,
        InputSearchModule,
        HighlightModule,
        AppDialogModule,
        PanelToolsModule,
        ButtonModule,
        OverlayModule,
        RestrictInputDirective,
        TableHeaderModule,
        TableCellsModule,
        EscapeHtmlPipe,
        PaletteLegendComponent,
        FuiTooltipDirective,
    ],
    exports: [
        TableComponent,
        SettingsTableDialogComponent,
        SettingsTableNameDialogComponent,
        TableSkeletonComponent,
        CustomPaginationComponent,
        TableAutoHeightDirective,
        TableFilterPortalDirective,
        TableHeaderModule,
    ],
})
export class TableModule {}
